module.exports = __webpack_public_path__ + "img/ws_logo.168db78c.png";